import { createContext, useContext } from "react";
const GroupContext = createContext(void 0);
function useGroupParent(componentName) {
  const context = useContext(GroupContext);
  if (!context) {
    throw new Error(`<Form.${componentName}> cannot be rendered outside the <Form.Group> component`);
  }
}
export {
  GroupContext,
  useGroupParent
};
//# sourceMappingURL=useGroupContext.js.map
